<template>
  <div id="recommendedService" class="recommended-service" v-if="data && data.length>0">
    <van-tabs v-model="actived" shrink :ellipsis="false">
      <van-tab v-for="(item, index) in data" :key="index" :title="item.objectName">
        <div class="s-tab-content">
          <ul class="s-grid-box" v-if="data.length>0">
            <template v-for="(item, idx) in data[actived].serviceList">
              <li :key="idx" v-if="idx<8" @click="serviceJump(item)">
                <span :class="'color' + (idx)">
                    <img
                      class="icon-img"
                      onload="SVGInject(this)"
                      round
                      fit="cover"
                      :src="complete(item.icon)"
                    />
                </span>
                <p>{{ item.name }}</p>
              </li>
            </template>
          </ul>
        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import { Tab, Tabs } from 'vant';
import {complete, baseURL} from "@/utils/url"
import * as svg from '@/utils/svg-inject.min'
import { getHotService } from '@/api/home/index'
import {serviceJump} from "@/utils/serviceUtil"
export default {
  name: "RecommendedService",
  components:{
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  data() {
    return {
      actived: 0,
      basePath: baseURL,
      data: []
    }
  },
  created() {
    this.getServiceList();
  },
  methods: {
    complete,
    //获取推荐服务及服务对象
    getServiceList() {
      getHotService().then(res => {
        if (res && res.code == 200) {
          this.data = res.data;
        }
      })
    },
    serviceJump
  }
}
</script>

<style lang="scss">
@import '~@/assets/css/theme/theme.scss';
//.van-tab--active
#recommendedService{
  ul.s-grid-box {
    padding: 0 0 15px;
    display: flex;
    flex-wrap: wrap;

    li {
      width: 25%;
      height: 85px;
      padding: 7px;
      box-sizing: border-box;
      text-align: center;
      flex: 0 0 25%;

      span {
        display: inline-block;
        width: 45px;
        height: 45px;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 23px;
        font-size: 21px;
        text-align: center;
        line-height: 45px;

        img,svg {
          display: block;
          width: 25px;
          height: 25px;
          fill: #ffffff;
        }

        &.color0, &.color5 {
          background: linear-gradient(-45deg, #F55359, #FD896C);
        }
        &.color1, &.color7 {
          background: linear-gradient(-45deg, #FAA452, #FEDC72);
        }
        &.color2, &.color4 {
          background: linear-gradient(-45deg, #5766F7, #6CABF5);
        }
        &.color3, &.color6 {
          background: linear-gradient(-45deg, #28D1A7, #4AE7B7);
        }
      }

      p {
        height: 20px;
        margin-top: 6px;
        color: $c333;
        line-height: 20px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @extend .font14;
      }
    }
  }
  .van-tab--active{
    font-size: 16px;
    font-weight: 600;
  }
  .van-tabs__line{
    display: none;
  }
}

</style>
